import script from "./CommonPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonPagination.vue?vue&type=script&setup=true&lang=ts"

import "./CommonPagination.vue?vue&type=style&index=0&id=9692d5a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9692d5a0"]])

export default __exports__